import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *团队成果
 * @param teamId
 * 
*/

export const result = teamId => Http.get(`${baseUrl}/sz/team/dw/${teamId}`)
